import { CmsSimpleResponsiveBannerComponent } from '@promo/const';

/**
 * Задает картинку для планшета и десктопа,
 * если контенты это сделать забыли иначе,
 * до 1200px у нас будет мобильная картинка
 */
export function tabletImageGenerator(banner: CmsSimpleResponsiveBannerComponent): CmsSimpleResponsiveBannerComponent {
  if (!banner.media) {
    return;
  }

  if (!banner.media.tablet) {
    return { ...banner, media: { ...banner.media, tablet: banner.media.desktop || banner.media.widescreen } };
  }

  return banner;
}
